// extracted by mini-css-extract-plugin
export default {"wrapHeader":"styles_wrapHeader__KefR4"};